import http from '@/http'
import { montaUrl } from '@/util/url-util'

export function getAll(filters) {
    let url = montaUrl(filters)
    return http.get(`/api/timeline?${url}`)
}